var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactBulle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 59,
    viewBox: "0 0 57 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0082de;}.b{fill:#fff;stroke:#097cd0;stroke-width:0.6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 28.5,
    cy: 29.5,
    rx: 28.5,
    ry: 29.5,
    transform: "translate(0.272 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-5593.4-343.294a9.2,9.2,0,0,0-1.4-.873,14.419,14.419,0,0,0-2.809-1.267,6.966,6.966,0,0,0,3.087-5.8,7,7,0,0,0-6.991-6.993,7,7,0,0,0-6.994,6.993,6.977,6.977,0,0,0,3.077,5.788,11.48,11.48,0,0,0-2.8,1.28,9.806,9.806,0,0,0-1.437.99,13.073,13.073,0,0,0-4.938,10.222.923.923,0,0,0,.9.9.922.922,0,0,0,.9-.9,11.3,11.3,0,0,1,11.289-11.288,11.3,11.3,0,0,1,11.286,11.288.923.923,0,0,0,.9.9.921.921,0,0,0,.9-.9C-5588.432-336.994-5591.057-341.65-5593.4-343.294Zm-8.112-13.136a5.2,5.2,0,0,1,5.192,5.194,5.2,5.2,0,0,1-5.192,5.195,5.2,5.2,0,0,1-5.2-5.195A5.2,5.2,0,0,1-5601.515-356.43Z",
    transform: "translate(5629.978 374.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBulle);
export default __webpack_public_path__ + "static/media/contact-bulle.f29b0c78e718a14d79479fa7bb29fabc.svg";
export { ForwardRef as ReactComponent };